import { authStore, mainStore } from '../stores';
import { history } from "./history-holder";
import { Auth } from 'aws-amplify';
import { ls } from '../utils';
import { SIGNUP_REDIRECT_SEARCH } from '../constants';

export const OAuth = {
    setData(data) {
        //mainStore.authUser = data.user;
        authStore.authUser = data.user;
        authStore.loggedIn = true;

        mainStore.preloaded = true;
    },

    cleanStorage() {
        authStore.loggedIn = false;
        ls.clear();
    },

    async autoLogin(cb) {
        try {
            const sessionUser = await Auth.currentAuthenticatedUser();
            if (sessionUser != null) {
                OAuth.setData({ user: Auth.user });
                if (history.location.search === SIGNUP_REDIRECT_SEARCH) {
                    history.replace('/login');
                }
                return;
            }
            else {
                OAuth.cleanStorage();
                history.replace('/login');
            }

        } catch (err) {
            if (history.location.search !== SIGNUP_REDIRECT_SEARCH) {
                history.replace('/login');
            }
        }
        if (history.location.search !== SIGNUP_REDIRECT_SEARCH) {
            history.replace('/login');
        }
    },

    async logout() {
        try {
            await Auth.signOut({ global: true });
            console.log("signed out...");
            
            // Add a delay to allow token invalidation to complete
            await new Promise(resolve => setTimeout(resolve, 1000)); // 1 second delay
            
            OAuth.cleanStorage();
            window.location.replace('/login');
        } catch (error) {
            console.log('error signing out: ', error);
            // Still clean up and redirect even if signOut fails
            OAuth.cleanStorage();
            window.location.replace('/login');
        }
    },
    hasScope(scope) {
        //add role admin
        return true;
    },
};
